import { MasterFSPMaintenanceConstant } from "presentation/constant/MasterFSP/MasterFSPMaintenanceConstant";
import { useMasterFSPMaintenanceVM } from "presentation/hook/MasterFSP/useMasterFSPMaintenanceVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useMasterFSPMaintenanceTracked } from "presentation/store/MasterFSP/MasterFSPMaintenanceProvider";
import { NbisIconButton } from "presentation/view/components/NbisIconButton";
import { memo, useCallback, useState } from "react";
import { HPHBreadcrumb, IconButton, Loader } from "veronica-ui-component/dist/component/core";
import { Breadcrumb, Sidebarheader, StyledAction } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const MasterFSPEditPanelTitleBar: React.FC = () => {
    const [masterFSPState] = useMasterFSPMaintenanceTracked();
    const masterFSPVM = useMasterFSPMaintenanceVM();
    const messageBarVM = useMessageBarVM();
    const { currentSelectedRow, masterState } = masterFSPState;
    const { editingEntity, isAdd, isEditable/*, isRead*/ } = masterState;

    const [isLoading, setIsLoading] = useState(false);
    const currentEntity = isEditable ? editingEntity : currentSelectedRow;
    const [anainfoState] = useANAInfoTracked();
    const { allowUpdate } = anainfoState;

    const handleReset = useCallback(async () => {
        masterFSPVM.onReset();
    }, [masterFSPVM]);

    const handleEdit = useCallback(() => {
        masterFSPVM.onEditClick(currentEntity);
    }, [currentEntity, masterFSPVM])

    const handleSave = useCallback(async () => {

        setIsLoading(true);
        try {
            masterFSPVM.onSaveClicked();
            const res = await masterFSPVM.onSave(currentEntity, isAdd);
            if (!!!res || !res.success) {
                res?.data && messageBarVM.showError(res?.data ?? 'Save data failed.');
            } else {
                masterFSPVM.onClose();
                messageBarVM.showSuccess("Save successfully.");
                masterFSPVM.searchMasterFSP(masterFSPState.searchCriteria);
            }
        } catch (error) {
            messageBarVM.showError('Save data failed.');
        } finally {
            setIsLoading(false)
        }

    }, [currentEntity, isAdd, messageBarVM, masterFSPVM, masterFSPState.searchCriteria]);

    return <Sidebarheader style={{ width: '100%' }}>
        {isLoading && <Loader Indicator="Spinner" size="Medium" />}
        <Breadcrumb>
            <HPHBreadcrumb breadcrumbData={[{ title: MasterFSPMaintenanceConstant.AGREEMENT },
            { title: MasterFSPMaintenanceConstant.TITLE }]} onCurrentClick={() => { }}>
            </HPHBreadcrumb>
        </Breadcrumb>
        <StyledAction>
            {allowUpdate && !(isAdd || isEditable) && currentEntity.masterType !== 'Country Code' &&
                <NbisIconButton fileName='Icon-pen' size='medium' toolTipText={'Edit'} toolTipArrow={false} onClick={handleEdit} disabled={false} />}
            {(isAdd || isEditable) && <IconButton fileName="Icon-reset" size="medium" toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Reset'} onClick={handleReset} />}
            {<IconButton fileName="Icon-cross" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="left" toolTipText={'Close'} onClick={masterFSPVM.onClose} />}
            {(isAdd || isEditable) && <IconButton fileName="Icon-tick" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Save'} onClick={() => handleSave()} />}
        </StyledAction>
    </Sidebarheader>
}

export default memo(MasterFSPEditPanelTitleBar);